
  <div class="login-container">
    <img src="../../assets/images/logos/investa-bill-white.png" alt="img" class="login-logo">
    <div class="login-box">
      <div class="login-header">
        <h2>FORGOT USERNAME</h2>
      </div>
      <form [formGroup]="forgotUsernameForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <input type="email" id="email" placeholder="Email" formControlName="email" required>
          <div *ngIf="f['email'].invalid && (f['email'].dirty || f['email'].touched)">
            <div class="error-msg" *ngIf="f['email'].errors?.['required']">Email is required.</div>
            <div class="error-msg" *ngIf="f['email'].errors?.['email']">Please enter a valid email address.</div>
          </div>
        </div>
        <div class="form-group">
          <button type="submit" [disabled]="forgotUsernameForm.invalid">{{submitText}}</button>
        </div>
      </form>
      <div class="login-links">
        <a routerLink="/login">Back to Login</a>
      </div>
    </div>
  </div>
